import { memo } from "react";

import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	guestTel: string;
};
export const GuestTelOfBasicInfoCompositions = memo(({ guestTel }: Props) => {
	return <BasicInfoLabelWithTextLayout label="電話番号" textChildren={<p>{guestTel}</p>} />;
});
